module.exports = __webpack_public_path__ + "img/AlBayan1.2971391c.jpg";